import * as React from 'react';
import Svg, {
  Defs,
  LinearGradient,
  Path,
  Stop,
  SvgProps,
} from 'react-native-svg';

const SvgLogo = (props: SvgProps) => (
  <Svg width={24} height={24} viewBox="0 0 56 51" fill="none" {...props}>
    <Path
      d="M28.344 50.61c1.847 0 3.694-.308 7.85-5.883 4.157-5.575 8.031-11.432 8.031-11.432l-25.297 9.377s4.233 7.938 9.416 7.938Z"
      fill="url(#logo_svg__a)"
    />
    <Path
      d="M44.225 33.295s8.287-12.46 10.52-22.093C55.641 6.398 55.205.027 48.33.309c-6.876.283-12.315 8.966-19.96 8.966C20.723 9.275 14.9.309 7.817.309 2.508.31.455 6.5.994 9.43c1.693 10.456 17.934 33.243 17.934 33.243l25.297-9.377Z"
      fill="url(#logo_svg__b)"
    />
    <Path
      d="M44.225 33.295s8.287-12.46 10.52-22.093C55.641 6.398 55.205.027 48.33.309c-3.925.154-6.03 2.492-10.262 4.984-.385.231-2.104 5.035-7.415 8.04-9.211 5.242-23.861 10.071-22.578 12.383.872 1.568 1.719 2.955 2.514 4.265 3.335 5.472 6.26 9.788 8.339 12.69l25.297-9.376Z"
      fill="url(#logo_svg__c)"
    />
    <Path
      d="M43.224 1.902s3.9 7.861-.872 14.412c-4.772 6.55-16.394 12.331-30.583 15.594C1.61 15.826.506 9.352 1.096 6.783 1.686 4.83-.315 20.039 13.54 17.547c13.854-2.492 20.294-9.685 20.294-9.685s3.104-1.619 3.54-2.081c.437-.462 5.645-3.88 5.85-3.88Z"
      fill="url(#logo_svg__d)"
    />
    <Path
      d="m39.556 4.265 3.67-2.363s3.309 6.936 0 12.999c0 0 2.231-5.703-3.67-10.636Z"
      fill="url(#logo_svg__e)"
    />
    <Defs>
      <LinearGradient
        id="logo_svg__a"
        x1={29.16}
        y1={35.599}
        x2={37.318}
        y2={44.971}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0.3} stopColor="#589C9A" />
        <Stop offset={0.77} stopColor="#458A9D" />
        <Stop offset={1} stopColor="#3A809E" />
      </LinearGradient>
      <LinearGradient
        id="logo_svg__b"
        x1={0.911}
        y1={21.488}
        x2={55.091}
        y2={21.488}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#1C95A2" />
        <Stop offset={1} stopColor="#21989A" />
      </LinearGradient>
      <LinearGradient
        id="logo_svg__c"
        x1={14.797}
        y1={36.653}
        x2={57.396}
        y2={7.954}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0.21} stopColor="#063CA6" />
        <Stop offset={0.47} stopColor="#0A6CAC" />
        <Stop offset={0.83} stopColor="#10ABB5" />
        <Stop offset={1} stopColor="#12C4B8" />
      </LinearGradient>
      <LinearGradient
        id="logo_svg__d"
        x1={0.965}
        y1={16.913}
        x2={44.728}
        y2={16.913}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#75A7CA" />
        <Stop offset={1} stopColor="#86C39F" />
      </LinearGradient>
      <LinearGradient
        id="logo_svg__e"
        x1={39.561}
        y1={8.412}
        x2={44.703}
        y2={8.412}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#71B497" />
        <Stop offset={1} stopColor="#61A598" />
      </LinearGradient>
    </Defs>
  </Svg>
);

export default SvgLogo;
